import React from "react";
import { useQuickSightAWSAccounts  } from "@/hooks/useAWSAccountsReports";

const QuickSightAWSAccountsDashboard = () => {
  const { embedUrl } = useQuickSightAWSAccounts ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAWSAccountsDashboard;
